import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopUpProvider } from '../../../../types/types';



const initialState:TopUpProvider[] = []

const giftCardProviders = createSlice({
  name: 'giftCardProviders',
  initialState,
  reducers: {
    setGiftCardProviders(state,action:PayloadAction<TopUpProvider[]>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default giftCardProviders.reducer;

// Actions
export const {setGiftCardProviders} = giftCardProviders.actions;

